import type { Ref } from "react";
import { ChoiceIndicator, type ChoiceIndicatorKind } from "./ChoiceIndicator";

interface ChoiceOptionButtonProps {
	indicator: ChoiceIndicatorKind;
	label: string;
	description?: string;
	selected: boolean;
	onClick: () => void;
	buttonRef?: Ref<HTMLButtonElement>;
	/** 下に入力欄を開いている。入力欄を除いたボタンだけが色付かないようホバーを付けない。 */
	expanded?: boolean;
}

/** 左端にラジオかチェックボックスを置く、質問の選択肢の行。 */
export function ChoiceOptionButton({
	indicator,
	label,
	description,
	selected,
	onClick,
	buttonRef,
	expanded = false,
}: ChoiceOptionButtonProps) {
	return (
		<button
			ref={buttonRef}
			type="button"
			data-selected={selected}
			onClick={onClick}
			className={`flex w-full items-start gap-3 px-4 pt-3 text-left text-ui text-fg-1 transition-colors disabled:opacity-40 ${
				expanded ? "pb-2" : "pb-3 enabled:hover:bg-row-hover-bg"
			}`}
		>
			<ChoiceIndicator kind={indicator} checked={selected} />
			<div className="min-w-0 flex-1 wrap-anywhere">
				<div className="font-medium">{label}</div>
				{description && <div className="mt-0.5 text-fg-3">{description}</div>}
			</div>
		</button>
	);
}
